<template>
    <div class="
      size-full flex flex-col

      lg:flex-row

      relative
    ">
        <customizer-current-step />
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";
</style>

<script>
    import CustomizerCurrentStep from '../CustomizerCurrentStep.vue';

    import allStores from '../../stores/all';
    import {
        STEP_REVIEW,
    } from '../../constants';

    export default {
        mixins: [allStores],

        data() {
            return {
                STEP_REVIEW,
            };
        },

        components: {
            CustomizerCurrentStep,
        },

        computed: {
            currentStep() {
                return this.appStore.currentStep;
            },
        },
    };
</script>
